module.exports = __webpack_public_path__ + "static/media/experiment.26381c72.svg";